import React from "react";

import { Module } from "@com.mgmtp.a12.client/client-core/lib/core/application";
import { View } from "@com.mgmtp.a12.client/client-core/lib/core/view";

import { CustomTreeEngine } from "./components/customTreeEngine";
import { CustomDirtyHandlingContainer } from "./components/editAntrag/dirtyHandlingModal";
import { FilteredTreeEngine } from "./components/filteredTreeEngine";
import { ProcessFormEngine } from "./components/processFormEngine";
import { detailsScreenValidationMiddleware } from "./middleware/detailsScreenValidationMiddleware";
import { rowActionRemoveRowMiddleware } from "./middleware/rowActionRemoveRowMiddleware";
import { selectTreeRowMiddleware } from "./middleware/selectTreeRowMiddleware";
import { closeTree } from "./sagas/closeTreeSaga";
import { acceptEditSaga } from "./sagas/editAntrag/acceptEditAntragSaga";
import { cancelEditAntragSaga } from "./sagas/editAntrag/cancelAntragEditSaga";
import { cancelNewAntragSaga } from "./sagas/editAntrag/cancelNewAntragSaga";
import { editAntragSaga } from "./sagas/editAntrag/editAntragSaga";
import { openTreeSaga } from "./sagas/openTreeSaga";
import { readonlyStateChangeSaga } from "./sagas/readonlyStateChangeSaga";
import { watchNodeConfirmSaga } from "./sagas/selectMultipleTextsSaga";
import { setFormEngineInitiallyReadonlySaga } from "./sagas/setFormEngineReadonlySagas";
import { lockProcessSaga } from "./sagas/lockProcessSaga";
import { pollingLockProcessSaga } from "./sagas/pollingLockProcessSaga";
import { setAttachmentUploadDateMiddleware } from "./middleware/setAttachmentUploadDateMiddleware";

/**
 * Client Modul um eine Form-Engine mit Prozessanzeige anzuzeigen
 */
const processFormEngineModule = (): Module => ({
	id: "ProcessFormEngine",
	views: () => viewComponentProvider,
	sagas: () => [
		openTreeSaga,
		closeTree,
		watchNodeConfirmSaga,
		readonlyStateChangeSaga,
		setFormEngineInitiallyReadonlySaga,
		lockProcessSaga,
		pollingLockProcessSaga,
		editAntragSaga,
		cancelEditAntragSaga,
		cancelNewAntragSaga,
		acceptEditSaga
	],
	middlewares: () => [
		detailsScreenValidationMiddleware,
		rowActionRemoveRowMiddleware,
		selectTreeRowMiddleware,
		setAttachmentUploadDateMiddleware
	]
});

const components: { [name: string]: React.ComponentType<View> | undefined } = {
	FilteredTreeEngine,
	CustomTreeEngine,
	ProcessFormEngine,
	CustomDirtyHandlingContainer
};

function viewComponentProvider(name: string) {
	return components[name];
}

export default processFormEngineModule;
